import axios from "axios";

const today = () => new Date().toISOString().split("T")[0];

// Same request DiagnosticReportsUnderwriter.handleSubmit sends to
// submit_diagnostic_report/ — HIP + file_data[0].detail[DiagnosticReport] +
// job_id — built from a finalized lab/radiology report instead of an AI parse.
// Throws on a non-"Success" response so the caller can stop the ABDM linking.
export const submitDiagnosticReport = async ({
  backendUrl,
  headers,
  patientId,
  careContextId,
  jobId = null,
  panels,
}) => {
  const detail = panels.map((panel) => ({
    resource_type: "DiagnosticReport",
    test_panel_code: null,
    test_panel_name: panel.name,
    test_report_date: today(),
    diagnostic_date: today(),
    conclusion: panel.conclusion ?? "",
    test_panel_observations: (panel.observations || []).map((o) => {
      const maybeNum = Number(o.value);
      const isNum = o.value !== "" && Number.isFinite(maybeNum);
      return {
        observation_code: null,
        observation_date: today(),
        observation_description: o.description ?? "",
        unit: o.unit || "",
        unit_code: null,
        value_boolean: null,
        value_codeable_concept: null,
        value_quantity: isNum ? maybeNum : o.value ?? null,
        value_string: isNum ? null : String(o.value ?? ""),
      };
    }),
  }));

  const payload = {
    HIP: "DiagnosticReport",
    file_data: [
      {
        patientID: patientId,
        careContextID: careContextId,
        detail: detail.map((d) => ({ ...d })),
      },
    ],
    job_id: jobId,
  };

  const resp = await axios.post(
    `${backendUrl}submit_diagnostic_report/`,
    payload,
    { headers },
  );
  if (resp.data?.status !== "Success") {
    throw new Error(resp.data?.message || "Diagnostic report submit failed");
  }
  return resp.data;
};
